import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      id: 0,
      name: '',
      description: '',
      tagline: '',
      disabled: false,
      isTaxable: true,
      categories: [],
      defaultItemId: 0,
      optionGroups: [],
      optionItems: [],
      img: '',
      allowsPersonalization: false,
      altImages: [],
      parentCategory: 0,
      relatedCategory: 0,
      preview: {
        portrait: [{
          img: '',
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          angle: 0,
        }],
        landscape: [{
          img: '',
          width: 0,
          height: 0,
          x: 0,
          y: 0,
          angle: 0,
        }],
      },
    },
  ],
  product: {
    id: 0,
    name: '',
    description: '',
    tagline: '',
    disabled: false,
    isTaxable: true,
    categories: [],
    defaultItemId: 0,
    optionGroups: [],
    optionItems: [],
    img: '',
    allowsPersonalization: false,
    altImages: [],
    parentCategory: 0,
    relatedCategory: 0,
    preview: {
      portrait: [{
        img: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        angle: 0,
        index: 1,
        z: 0,
        zoomedOverlay: '',
        zoomedX: 0,
        zoomedY: 0,
        zoomedWidth: 0,
        zoomedHeight: 0,
      }],
      landscape: [{
        img: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        angle: 0,
        index: 1,
        z: 0,
        zoomedOverlay: '',
        zoomedX: 0,
        zoomedY: 0,
        zoomedWidth: 0,
        zoomedHeight: 0,
      }],
      numPhotos: 1,
    },
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/products?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 0,
    limit: 20,
  },
};

function products(state = initialState, action) {
  switch (action.type) {
    case types.PRODUCTS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.PRODUCTS_FETCH_ERROR:
    case types.PRODUCT_FETCH_ERROR:
    case types.PRODUCT_EDIT_ERROR:
    case types.PRODUCT_SET_ERROR:
    case types.PRODUCT_DELETE_ERROR:
    case types.PRODUCT_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.PRODUCT_FETCH_SUCCESS:
    case types.PRODUCT_EDIT_SUCCESS:
    case types.PRODUCT_SET_SUCCESS:
      return assign({}, state, {
        product: action.res,
      });
    case types.PRODUCT_CATALOGS_FETCH_SUCCESS:
    // TODO: append the list of catalogs to products
      return assign({}, state, {
        product: state.product,
        catalogs: action.res,
      });
    case types.PRODUCT_DELETE_SUCCESS:
      return assign({}, state, {
        productDelete: action.res.ok,
      });
    case types.PRODUCTS_CLEAR_ERRORS:
      return assign({}, state, {
        error: '',
      });
    default:
      return state;
  }
}

export default products;



// WEBPACK FOOTER //
// ./src/reducers/products.js